import type { ChangelogEntry } from "../types";

/**
 * VIB-2771. Redirecten fra forsiden ventet ikke på tilgangene.
 *
 * Ingen rollekrav: feilen traff alle roller uten Måltall, og hardest de
 * eksterne, som har færrest sider å lande på.
 */
export const RBAC_REDIRECT_2026_10: ChangelogEntry = {
  id: "2026-10-05-rbac-redirect",
  date: "2026-10-05",
  title: "Du havner på riktig side når du logger inn",
  summary:
    "Forsiden kunne sende deg til Hjelp før systemet hadde rukket å lese tilgangene dine, og da ble du stående der.",
  sections: [
    {
      heading: "Overalt i Revehiet",
      items: [
        {
          title: "Innlogging sender deg dit du faktisk hører hjemme",
          kind: "rettet",
          body: "Har du ikke Måltall, sender forsiden deg videre til den første siden du har tilgang til. Den videresendingen kunne skje før tilgangene var lest, og da havnet du på Hjelp i stedet. Siden videresendingen erstatter adressen, ble du stående på Hjelp resten av økten, uten noe som forklarte hvorfor. Nå venter systemet til tilgangene er på plass før det sender deg videre.",
        },
        {
          title: "Samme retting under Innstillinger",
          kind: "rettet",
          body: "Åpnet du Innstillinger uten å velge en underside, kunne du på samme måte bli sendt til en tilfeldig underside i stedet for din egen. Den venter nå også.",
        },
      ],
    },
  ],
};
